// Auto generated file, do not manually modify!
// com.hotpads.googlemaps.web.handler.GoogleMapsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GoogleMapsAddSignatureAndKeyToUrlRequestDto, GoogleMapsAddSignatureAndKeyToUrlResponseDto } from '../..';

export const GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Path =
  '/api/web/v1/users/googleMaps/addSignatureAndKeyToUrl';

/**
 * Add GoogleMap signature and key to URL
 */
export const GoogleMapsWebApiHandler_addSignatureAndKeyToUrl = (
  postData: GoogleMapsAddSignatureAndKeyToUrlRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GoogleMapsAddSignatureAndKeyToUrlRequestDto,
    GoogleMapsAddSignatureAndKeyToUrlResponseDto
  >(
    {
      endpoint: GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
